export const MUSIC_LESSON_FORMAT_VALUES = ['one_to_one', 'group'] as const;
export type MusicLessonFormat = (typeof MUSIC_LESSON_FORMAT_VALUES)[number];

export const MUSIC_PHYSICAL_VENUE_VALUES = ['student_home', 'tutor_studio'] as const;
export type MusicPhysicalVenue = (typeof MUSIC_PHYSICAL_VENUE_VALUES)[number];
